import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IData, IDataNoPagination } from '../types/shared';

// ============================================================================
// Tipos
// ============================================================================

export interface ICartorio {
  id: number;
  nome: string;
  telefone: string | null;
  endereco: string | null;
  email: string | null;
  dt_criacao: string;
  dt_atualizacao: string;
}

export interface ICartorioPayload {
  nome: string;
  telefone?: string | null;
  endereco?: string | null;
  email?: string | null;
}

export interface IListCartoriosFilters {
  search?: string;
  page?: number;
  size?: number;
}

// ============================================================================
// Hook
// ============================================================================

export const useCartorios = () => {
  const listCartorios = async (key: QueryFunctionContext): Promise<IData<ICartorio[]>> => {
    const filters = (key.queryKey?.[1] ?? {}) as IListCartoriosFilters;
    const res = await api.get<IData<ICartorio[]>>('/api/v1/cartorios/', { params: filters });
    return res.data;
  };

  const getCartorio = async (id: number): Promise<IDataNoPagination<ICartorio>> => {
    const res = await api.get<IDataNoPagination<ICartorio>>(`/api/v1/cartorios/${id}`);
    return res.data;
  };

  const createCartorio = async (data: ICartorioPayload): Promise<IDataNoPagination<ICartorio>> => {
    const res = await api.post<IDataNoPagination<ICartorio>>('/api/v1/cartorios/', data);
    return res.data;
  };

  const updateCartorio = async (
    id: number,
    data: Partial<ICartorioPayload>,
  ): Promise<IDataNoPagination<ICartorio>> => {
    const res = await api.put<IDataNoPagination<ICartorio>>(`/api/v1/cartorios/${id}`, data);
    return res.data;
  };

  return { listCartorios, getCartorio, createCartorio, updateCartorio };
};
